import React from 'react';

interface PullQuoteProps {
  text: string;
  personaColor: string;
}

const PullQuote: React.FC<PullQuoteProps> = ({ text, personaColor }) => {
  return (
    <div className="my-7" style={{ paddingLeft: '24px', borderLeft: `3px solid ${personaColor}` }}>
      <p
        className="text-[22px] font-semibold italic text-[#0f172a] leading-[1.5]"
        style={{ fontFamily: "'Source Serif 4', Georgia, serif" }}
      >
        &ldquo;{text}&rdquo;
      </p>
    </div>
  );
};

export default PullQuote;
